import { useEffect } from "react";
import ym from "react-yandex-metrika";

import initialData from "../quest_script.json";

import "./GameScreen.scss";
import "./EndingScreen.scss";

const endScreenData = [
  {
    id: "21",
    header_top: "GAME",
    header_bottom: "over",
    description: (
      <div className="dialog__description_text">
        <div>
          Нужно больше золота!
          <br />
          Череда инвестиционных ошибок привела к проигрышу — тебе придется
          уехать назад в прошлое чуть раньше…{" "}
          <span className="ending_screen__description-red">
            К счастью, у «Альфа-Капитала» уже сейчас есть стратегия по индустрии
            видеоигр,
          </span>{" "}
          где за тебя выбор сделают профессионалы.
        </div>
      </div>
    ),
    expression: "defaultLeft.png",
    robot_line: (
      <div>
        <span className="ending_screen__robot_line-red">
          Кликай по кнопке, чтобы получить консультацию
        </span>
        <span>
          {" "}
          и +100 к добыче ресурсов!
          <br /> Или начни игру заново.
        </span>
      </div>
    ),
  },
  {
    id: "22",
    header_top: "MISSION",
    header_bottom: "complete",
    description: (
      <div className="dialog__description_text">
        <div>
          В виртуальном будущем ты принимал инвестиционные решения
          самостоятельно, но угадать последствия ходов было непросто. К счастью,
          у{" "}
          <span className="ending_screen__description-red">
            «Альфа-Капитала» уже сейчас есть стратегия по индустрии видеоигр,
          </span>{" "}
          где за тебя выбор сделают профессионалы.
        </div>
      </div>
    ),
    expression: "happyLeft.png",
    robot_line: (
      <>
        <span className="ending_screen__robot_line-red">
          Кликай по кнопке, чтобы получить консультацию
        </span>
        <span>
          {" "}
          и +100 к добыче ресурсов!
          <br /> Или начни игру заново.
        </span>
      </>
    ),
  },
];

const RobotLinePlate = ({ children }) => (
  <div className="dialog">
    <img
      className="dialog__robot_line_plate dialog__robot_line_plate-top-right"
      src="../assets/robotLinePlate1.png"
      alt="Robot Line Element 1"
    />
    <div className="dialog__robot_line_background dialog__robot_line_background-right">
      <img src="../assets/plates/bigPlateRight.png" alt="Robot Line Plate" />
      <div className="dialog__robot_line_text dialog__robot_line_text-right dialog__robot_line_text_secret">
        {children}
      </div>
    </div>
    <img
      className="dialog__robot_line_plate dialog__robot_line_plate-bottom-right"
      src="../assets/robotLinePlate2.png"
      alt="Robot Line Element 2"
    />
  </div>
);

function EndingScreen(props) {
  const { questProgress } = props;
  const endScriptIdx = questProgress.score > 0 ? 1 : 0;

  const onLearnMoreClick = () => {
    window.fbq("track", "ViewContent");
    window.open("https://www.alfacapital.ru/individual/am/games/?utm_source=nerv&utm_medium=media&utm_campaign=media_game_videogames");

    
    ym("reachGoal", `btn_product_${questProgress.level === 11 ? "1" : questProgress.score >= 0 ? "2" : "3"}`);
  };

  useEffect(() => {
    ym("reachGoal", "final");
    ym(
      "reachGoal",
      `final_${
        questProgress.level === 11 ? "1" : endScriptIdx === 1 ? "2" : "3"
      }`
    );
  }, [questProgress, endScriptIdx]);

  return (
    <>
      {questProgress.level === 11 ? (
        <>
          <div className={"container__image_container"}>
            <img
              className="ending_screen__image"
              src={`../assets/cases/${initialData[10].answer[0].image}`}
              alt="Бассейн без лестницы"
            />
            <img
              className="ending_screen__image_border"
              src={`../assets/imageBorder.png`}
              alt="Border"
            />
          </div>
          <div className="dialog__description">
            <img
              className="dialog__description_top_line"
              src="../assets/descriptionTopLine.png"
              alt="Description Top Line"
            ></img>
            <img
              className="dialog__description_bar_left"
              src="../assets/descriptionBarLeft.png"
              alt="Description Bar Left"
            ></img>
            <div className="dialog__description_text">
              {initialData[10].answer[0].description}
            </div>
          </div>
          <RobotLinePlate>
            <span>А чтобы уберечься от рискованных решений уже сейчас — </span>
            <span className="ending_screen__robot_line-red">
              воспользуйся стратегией «Альфа-Капитала» по индустрии видеоигр.
            </span>
            <span>
              {" "}
              Кликай по кнопке, чтобы получить консультацию и +100 к добыче
              ресурсов!
            </span>
          </RobotLinePlate>
        </>
      ) : (
        <>
          <div className="ending_screen__header_container">
            <div className="ending_screen__header">
              <div
                className={
                  endScriptIdx === 1
                    ? "ending_screen__header-top-win"
                    : "ending_screen__header-top-lose"
                }
              >
                {endScreenData[endScriptIdx].header_top}
              </div>
              <div
                className={
                  endScriptIdx === 1
                    ? "ending_screen__header-bottom-win"
                    : "ending_screen__header-bottom-lose"
                }
              >
                {endScreenData[endScriptIdx].header_bottom}
              </div>
              {endScriptIdx === 1 && (
                <div className="end_screen__header_score">
                  SCORE {questProgress.score}K
                </div>
              )}
              <img
                className={
                  endScriptIdx === 1
                    ? "ending_screen__header_line-left-win"
                    : "ending_screen__header_line-left-lose"
                }
                src={
                  endScriptIdx === 1
                    ? "../assets/endingScreenLineWin.png"
                    : "../assets/endingScreenLineLose.png"
                }
                alt="Left Line"
              ></img>
              <img
                className={
                  endScriptIdx === 1
                    ? "ending_screen__header_line-right-win"
                    : "ending_screen__header_line-right-lose"
                }
                src={
                  endScriptIdx === 1
                    ? "../assets/endingScreenLineWin.png"
                    : "../assets/endingScreenLineLose.png"
                }
                alt="Right Line"
              ></img>
            </div>
            <div className="dialog__description">
              <img
                className="dialog__description_top_line"
                src="../assets/descriptionTopLine.png"
                alt="Description Top Line"
              ></img>
              <img
                className="dialog__description_bar_left"
                src="../assets/descriptionBarLeft.png"
                alt="Description Bar Left"
              ></img>
              {endScreenData[endScriptIdx].description}
            </div>
          </div>
          <RobotLinePlate>
            {endScreenData[endScriptIdx].robot_line}
          </RobotLinePlate>
        </>
      )}

      <img
        onClick={props.onRobotAnswerSkip}
        className="ending_screen__robot_image-left"
        src={`/assets/robot/${
          questProgress.level === 11
            ? "defaultLeft.png"
            : questProgress.score <= 0
            ? "defaultLeft.png"
            : "happyLeft.png"
        }`}
        alt="robot"
      />
      <div className="ending_screen__button">
        <div className="ending_screen__learnmore_container">
          <div className="ending_screen__button_text">ХОЧУ ВСЁ ЗНАТЬ!</div>
          <button
            className="ending_screen__button_learnmore"
            onClick={onLearnMoreClick}
          ></button>
        </div>
        <div className="ending_screen__restart_container">
          <button
            className="ending_screen__button_restart"
            onClick={props.onPlayAgain}
          >
            <img
              className="ending_screen__arrow_restart"
              src={"./assets/arrow.png"}
              alt="Restart Arrow"
            />
          </button>
        </div>
      </div>
    </>
  );
}

export default EndingScreen;
